import React from 'react';
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Theme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useI18n } from '../../lib/hook/useI18n';
import PrivacyPolicyLink from './PrivacyPolicyLink';
import UnifiedConsentContent from './UnifiedConsentContent';

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    marginLeft: theme.spacing(3),
  },
}));

interface Props {
  isConsentDeclinedSuppression?: boolean;
  shouldUseUnifiedConsent?: boolean;
  onAccept?: () => void;
  onReject?: () => void;
  privacyPolicyName?: string;
}

const ConsentPrompContent: React.FC<Props> = (
  props: Props
): JSX.Element | null => {
  const {
    onAccept,
    onReject,
    privacyPolicyName,
    isConsentDeclinedSuppression,
    shouldUseUnifiedConsent,
  } = props;

  const { t, tc, tHtml } = useI18n();
  const classes = useStyles();

  if (shouldUseUnifiedConsent) {
    return (
      <UnifiedConsentContent
        isConsentDeclinedSuppression={isConsentDeclinedSuppression}
        onReject={onReject}
        onAccept={onAccept}
        privacyPolicyName={privacyPolicyName}
      />
    );
  }

  return (
    <>
      <DialogTitle>{t('consent.title')}</DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Box mb={1} />
          <Box mx={1}>
            <DialogContentText
              color="textSecondary"
              component="div"
              variant="body2"
            >
              {t('consent.body.description_1')}
              <br />
              <br />
              {t('consent.body.description_2')}
              <br />
              <br />
              {t('consent.body.list_description')}
              <br />
              <Box className={classes.list}>
                {tHtml('consent.body.list_items')}
              </Box>
              {tc(
                'consent.body.terms',
                {},
                {
                  0: (
                    <PrivacyPolicyLink privacyPolicyName={privacyPolicyName} />
                  ),
                }
              )}
            </DialogContentText>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onReject}>
          {t('consent.body.reject')}
        </Button>
        <Button color="secondary" onClick={onAccept} variant="contained">
          {t('consent.body.accept')}
        </Button>
      </DialogActions>
    </>
  );
};

export default ConsentPrompContent;
